'use strict';

var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var isFunction = require('@userzoomlibraries/toolkit-js-utils/is-function');
var isObject = require('@userzoomlibraries/toolkit-js-utils/is-object');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var isFunction__default = /*#__PURE__*/_interopDefaultCompat(isFunction);
var isObject__default = /*#__PURE__*/_interopDefaultCompat(isObject);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Get the theme definition for a given COMPONENT_ID.
 *
 * @function
 * @param {object} [parameter={}] - Object with 'componentId' and 'props'.
 * @param {string} parameter.componentId - ComponentID of the component.
 * @param {object} [parameter.props={}] - Props of the component.
 * @returns {string} Returns the styles theme for the given component.
 * @example
 * getThemeByProps({ componentId: Button.COMPONENT_ID });
 * // => '.gz-button { ... }'
 */

var getThemeByProps = function getThemeByProps() {
  var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (isObject__default["default"](parameter)) {
    var componentId = parameter.componentId,
        _parameter$props = parameter.props,
        props = _parameter$props === void 0 ? {} : _parameter$props;
    var styles = props.theme.styles;
    var componentTheme;

    if (styles) {
      componentTheme = styles[componentId];

      if (isFunction__default["default"](componentTheme)) {
        componentTheme = componentTheme(props);
      }
    }

    return componentTheme;
  }

  throw new TypeError('Invalid type, Object type expected.');
};

getThemeByProps.HELPER_ID = 'Gearz.ThemeManager.getThemeByProps';
getThemeByProps.returnType = PropTypes__default["default"].oneOfTypeWithDescription([PropTypes__default["default"].string, PropTypes__default["default"].arrayOf(PropTypes__default["default"].string), PropTypes__default["default"].arrayOf(PropTypes__default["default"].arrayOf(PropTypes__default["default"].string)) // needed for css method of styled-components
], 'styled-component CSS object with the component styles.');
getThemeByProps.parameterTypes = {
  parameter: PropTypes__default["default"].shapeWithDescription({
    componentId: PropTypes__default["default"].stringWithDescription('Id of the component.'),
    props: PropTypes__default["default"].objectWithDescription('Props of the component.')
  }, 'Object with the component ID and the props of the component.')
};
getThemeByProps.defaultParameters = {
  parameter: {
    props: {}
  }
};

module.exports = getThemeByProps;
